export default __webpack_public_path__ + "static/banner_chicago-405c244d5201b448d21ebb41a0a504d6.webp";